var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#101010","d":"M14.6 0H5.4A5.4 5.4 0 000 5.4v9.2A5.4 5.4 0 005.4 20h9.2a5.4 5.4 0 005.4-5.4V5.4A5.4 5.4 0 0014.6 0zm3.8 14.6a3.8 3.8 0 01-3.8 3.8H5.4a3.8 3.8 0 01-3.8-3.8V5.4a3.8 3.8 0 013.8-3.8h9.2a3.8 3.8 0 013.8 3.8zm-3.9-5.3a4.1 4.1 0 00-1.3-2.5 5 5 0 00-2.5-1.3H9.4a4.3 4.3 0 00-2.9 1.8 4.3 4.3 0 00-.8 3.3 4.3 4.3 0 001.8 2.9 4.4 4.4 0 002.7.9h.7a4.3 4.3 0 002.9-1.8 4.6 4.6 0 00.7-3.3zm-4 3.5a3 3 0 01-2.1-.5 2.9 2.9 0 01-1.1-1.9 3 3 0 01.5-2.1 2.9 2.9 0 011.9-1.1h.8a2.9 2.9 0 012.4 2.4 2.9 2.9 0 01-2.4 3.2zm5.1-8.4a.7.7 0 00-.6-.2l-.6.2a.7.7 0 00-.2.6 1.4 1.4 0 00.2.6.7.7 0 00.6.2l.6-.2a.7.7 0 00.2-.6.4.4 0 00-.2-.6z"}));
}

Instagram.defaultProps = {"viewBox":"0 0 20 20","aria-label":"Instagram"};

module.exports = Instagram;

Instagram.default = Instagram;
